import { render } from "./ProjectCostReport.vue?vue&type=template&id=52f44c85&scoped=true"
import script from "./ProjectCostReport.vue?vue&type=script&lang=js"
export * from "./ProjectCostReport.vue?vue&type=script&lang=js"

import "./ProjectCostReport.vue?vue&type=style&index=0&id=52f44c85&scoped=true&lang=css"
import "./ProjectCostReport.vue?vue&type=style&index=1&id=52f44c85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f44c85"]])

export default __exports__